import { getYMDHMS, toParam, uuid4 } from '@/utils/mUtil'

let url_click = ''

if (/ipad/.test(navigator.userAgent.toLowerCase())) {
  url_click = 'http://ipad.v0.data.mgtv.com/follow.php'
} else if (/iphone/.test(navigator.userAgent.toLowerCase())) {
  url_click = 'http://iphone.v0.mgtv.com/follow.php'
} else {
  url_click = 'http://aphone.v0.mgtv.com/follow.php'
}

let url_pv = ''

if (/ipad/.test(navigator.userAgent.toLowerCase())) {
  url_pv = 'http://ipad.v0.data.mgtv.com/pv.php'
} else if (/iphone/.test(navigator.userAgent.toLowerCase())) {
  url_pv = 'http://iphone.v0.mgtv.com/pv.php'
} else {
  url_pv = 'http://aphone.v0.mgtv.com/pv.php'
}

// click 上报公共参数
function _clickCommParams() {
  const DEVICEINFO = window.DEVICEINFO || {}
  const USERINFO = window.USERINFO || {}
  return {
    time: getYMDHMS(),
    guid: '',
    did: DEVICEINFO.did || '',
    uuid: USERINFO.uuid || '',
    sid: DEVICEINFO.sid || '',
    net: DEVICEINFO.net || '',
    isdebug: 0,
    mf: DEVICEINFO.mf || '',
    mod: DEVICEINFO.mod || '',
    sver: DEVICEINFO.sver || '',
    aver: DEVICEINFO.aver || '',
    gps: DEVICEINFO.gps || '',
    ch: DEVICEINFO.ch || '',
    mac: DEVICEINFO.mac || '',
    bdsv: '',
    uvip: USERINFO.vipinfo ? USERINFO.vipinfo.isvip : 0,
    rdc: '',
    rch: '',
    abroad: 0,
    runsid: '',
    src: 'mgtv',
    act: 'credits',
    dc: uuid4(),
    cpn: '56', // 积分页面编码=56
    cpid: encodeURIComponent(location.href),
    rtime: '',
    value: '',
    pos: '',
    ntime: Date.now(),
    agemod: 0,
  }
}

// pv 上报公共参数 http://wiki.imgo.tv/pages/viewpage.action?pageId=2929893
function _pvCommParams() {
  return {
    abroad: 0,
    act: 'pvs',
    aver: DEVICEINFO.aver || '',
    ch: DEVICEINFO.ch || '',
    cpid: encodeURIComponent(location.href),
    cpn: '56', // 积分页面编码=56
    did: DEVICEINFO.did || '',
    fpid: '',
    fpn: 5,
    gps: DEVICEINFO.gps || '',
    idfa: DEVICEINFO.idfa || '',
    isfull: 0,
    mf: DEVICEINFO.mf || '',
    mod: DEVICEINFO.mod || '',
    net: DEVICEINFO.net || '',
    runsid: '',
    sid: DEVICEINFO.sid || '',
    src: 'mgtv',
    sver: DEVICEINFO.sver || '',
    time: getYMDHMS(),
    uuid: USERINFO.uuid || '',
    uvip: USERINFO.vipinfo ? USERINFO.vipinfo.isvip : 0,
    url: location.href,
  }
}

export default {
  click(params, callback) {
    let img = new Image()
    img.src =
      url_click + '?' + toParam(Object.assign({}, _clickCommParams(), params))

    img.onload = () => {
      console.log('report click >>>', img.src)
      img = null

      if (typeof callback === 'function') callback()
    }

    img.onerror = () => {
      console.log('report click >>>', img.src)
      img = null

      if (typeof callback === 'function') callback()
    }
  },

  pv(callback) {
    let img = new Image()
    img.src = url_pv + '?' + toParam(_pvCommParams())

    img.onload = () => {
      console.log('report pv >>>', img.src)
      img = null

      if (typeof callback === 'function') callback()
    }

    img.onerror = () => {
      console.log('report pv >>>', img.src)
      img = null

      if (typeof callback === 'function') callback()
    }
  },
}
